import React, { useEffect, useState } from "react";

import "../Main.css";
import { Button } from "@mui/material";
import { HOST_URL } from "../common";

const LogoutScreen = () => {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = () => {
    //const url = 'http://30.30.30.3:3002/api';
    const url = HOST_URL + ":3002/api";
    fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "ok") {
          setUserName(result.user[0].name);
        } else if (result.code === "error") {
          window.alert(result.reason);
          window.location.href = "/";
        }
      });
  };

  const handleLogout = () => {
    //const url = 'http://30.30.30.3:3002/logout'
    const url = HOST_URL + ":3002/logout";
    fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "ok") {
          window.location.href = "/";
        }
      });
  };

  return (
    <div className="Main-container">
      <div>
        <h2>KSIC 개발자 포털 로그인</h2>

        <div style={{ display: "flex", flexDirection: "column", padding: 10 }}>
          <h3>{userName}</h3>

          <Button
            variant="contained"
            style={{ margin: 10 }}
            onClick={handleLogout}
          >
            LOGOUT
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogoutScreen;
